var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import { getTranslationByKey } from '@ui/common/js/data/translations_data';
import { setState, getObservable } from '../data/login_data';
import { SetStateMessages, GetObservableMessages } from '../models/models';
import { isMobile } from '@ui/common/js/utils/agent_checker';
let RequestAccessForm = class RequestAccessForm extends LitElement {
    constructor() {
        super();
        this.locationOptions = [];
        document.getElementById('body2').addEventListener('language_selected', () => {
            super.requestUpdate();
        });
    }
    createRenderRoot() {
        return this;
    }
    render() {
        return html `
            <div class="${isMobile() ? 'modal_mobile' : 'modal'}">
                <div class="login_modal_header">
                    <div class="modal_title">
                        <dn-icon
                            style="cursor: pointer;"
                            color="#2160F4"
                            fontawesomeIcon="fa-arrow-left"
                            @click="${() => this.backToLoginForm()}"
                        ></dn-icon>
                        <h2 style="margin-left: 1em;">${getTranslationByKey('request_login_title')}</h2>
                    </div>
                    <div class="modal_subtitle">
                        ${getTranslationByKey('request_access_subtitle')}
                    </div>
                </div>
                <div>
                    <dn-input-field
                        label="${getTranslationByKey('email_input')}"
                        @change="${(e) => this.email = e.detail.value}"
                        valid
                    ></dn-input-field>
                    ${this.locationOptions.length > 0 ? html `
                        <div style="margin-bottom: 2em;">
                            <dn-dropdown
                                items="${JSON.stringify(this.locationOptions)}"
                                placeholder="please select a location"
                                @selected="${(e) => this.location = e.detail.selection}"
                            ></dn-dropdown>
                        </div>
                    ` : ''}
                    <dn-button
                        text="${getTranslationByKey('register_button')}"
                        @click="${() => this.requestAccess()}"
                    ></dn-button>
                    <div style="height: 2em;"></div>
                    ${this.requestInfo ? html `
                        <div class="${this.requestInfo.success ? 'request_access_success' : 'request_access_failed'}">
                            ${getTranslationByKey(this.requestInfo?.info)}
                        </div>
                    ` : ''}
                </div>
            </div>
        `;
    }
    backToLoginForm() {
        super.dispatchEvent(new CustomEvent('back'));
    }
    requestAccess() {
        this.emailValid = setState({
            type: SetStateMessages.REQUEST_ACCESS,
            data: {
                email: this.email,
                location: this.location,
            },
        });
    }
    firstUpdated() {
        getObservable(GetObservableMessages.REQUEST_ACCESS_INFORMATION).subscribe(info => {
            this.requestInfo = info;
        });
        getObservable(GetObservableMessages.LOCATION_OPTIONS).subscribe(options => {
            this.locationOptions = options;
        });
    }
};
__decorate([
    property({ type: String })
], RequestAccessForm.prototype, "emailValid", void 0);
__decorate([
    property({ type: Object })
], RequestAccessForm.prototype, "requestInfo", void 0);
__decorate([
    property()
], RequestAccessForm.prototype, "locationOptions", void 0);
RequestAccessForm = __decorate([
    customElement('request-access-form')
], RequestAccessForm);
export default RequestAccessForm;
